// base
export const TAB = 'TAB';

// 用户
export const USER_LOGIN = 'USER_LOGIN'; //登录

// 修改IP

export const SET_IPFROM = 'SET_IPFROM'; //ip

// 修改视频
export const SET_VIDEO = 'SET_VIDEO'; //ip


// WEBPACK FOOTER //
// ./src/store/types.js